const routes = {
  auth: '/auth',
  authAction: '/auth/action',
  onboard: '/onboard',
  pageNotFound: '/*',
  portal: {
    documents: '/documents',
    earnings: '/earnings',
    home: '/',
    profile: '/profile',
    rides: '/earnings/:earningId/rides',
    schedule: '/schedule',
    training: '/training',
  },
  root: '*',
}

export default routes
